// --------------------------------------------------------------
// Created On: 2021-12-14
// Author: Zachary Thomas
//
// Last Modified: 2026-09-29
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { configureStore } from "@reduxjs/toolkit";
import currentUserReducer from "./features/currentUserSlice";
import idTokenReducer from "./features/idTokenSlice";
import accessTokenReducer from "./features/accessTokenSlice";
import refreshTokenReducer from "./features/refreshTokenSlice";
import sessionTokenReducer from "./features/sessionTokenSlice";
import notificationsReducer from "./features/notificationsSlice";
import assetGraphAttributesReducer from "./features/assetGraphAttributesSlice";
import mobileMfaChallengeRequiredReducer from "./features/mobileMfaChallengeRequiredSlice";
import mobileMfaSetupRequiredReducer from "./features/mobileMfaSetupRequiredSlice";
import mobileNewPasswordRequiredReducer from "./features/mobileNewPasswordRequiredSlice";

export const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,
    idToken: idTokenReducer,
    accessToken: accessTokenReducer,
    refreshToken: refreshTokenReducer,
    sessionToken: sessionTokenReducer,
    notifications: notificationsReducer,
    assetGraphAttributes: assetGraphAttributesReducer,
    mobileMfaChallengeRequired: mobileMfaChallengeRequiredReducer,
    mobileMfaSetupRequired: mobileMfaSetupRequiredReducer,
    mobileNewPasswordRequired: mobileNewPasswordRequiredReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type ReduxDispatch = typeof store.dispatch;
